module.exports = __webpack_public_path__ + "img/icone-user-edit.d3606da1.svg";